import { signIn } from '../auth/oidc';

/** Full-page state shown before the app renders in OIDC mode: redirecting, signed out, or a callback error. */
export function AuthScreen({ kind, message }: { kind: 'redirecting' | 'signed-out' | 'loading' | 'error'; message?: string }) {
  const text = {
    loading: 'Signing in…',
    redirecting: 'Redirecting to sign-in…',
    'signed-out': 'You are signed out.',
    error: `Sign-in failed: ${message ?? 'unknown error'}`,
  }[kind];
  return (
    <div className="auth-screen">
      <div className="auth-card">
        <div className="brand-title">Press Shop Twin</div>
        <p>{text}</p>
        {(kind === 'signed-out' || kind === 'error') && (
          <button className="btn primary" onClick={() => signIn()}>Sign in</button>
        )}
      </div>
    </div>
  );
}
